import { Vue, Component, Prop, Watch} from 'vue-property-decorator';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { LibrariesModel } from '@/models/libraries/libraries';
import { numberFormatWithTextSuffix } from '@/helpers/number-format';
import { CATALOG_MENUS, DEFAULT_IMAGES_PATH } from '@/utils/constants';

@Component({
    name: 'partner-card',
    components: {
        'library-icon': MCIcon,
    },
})

export default class PartnerCard extends Vue {

    @Prop()
    private partnerContent!: LibrariesModel;

    @Prop({default: false})
    private isActivityContent!: boolean;

    private partnerDefaultImage = DEFAULT_IMAGES_PATH.partner;

    get hasCollection() {
        return this.partnerContent.collectionCount;
    }

    get hasAssessment() {
        return this.partnerContent.assessmentCount;
    }

    get hasQuestion() {
        return this.partnerContent.questionCount;
    }

    get hasResource() {
        return this.partnerContent.resourceCount;
    }

    get hasCourse() {
        return this.partnerContent.courseCount;
    }

    get hasRubric() {
        return this.partnerContent.rubricCount;
    }

    get hasOfflineActivity() {
        return this.partnerContent.offlineActivityCount;
    }

    // ---------------------------------------------------------------------------
    // Actions

    private onClickPartner(library: LibrariesModel) {
        if (!this.isActivityContent) {
            if (this.hasCollection) {
                window.location.href = `/library/library-search?libraryId=${library.id}&activeContentType=collection&type=library`;
            } else if (this.hasAssessment) {
                window.location.href = `/library/library-search?libraryId=${library.id}&activeContentType=assessment&type=library`;
            } else if (this.hasResource) {
                window.location.href = `/library/library-search?libraryId=${library.id}&activeContentType=resource&type=library`;
            } else if (this.hasQuestion) {
                window.location.href = `/library/library-search?libraryId=${library.id}&activeContentType=question&type=library`;
            } else {
                window.location.href = `/library/library-search?libraryId=${library.id}&type=library`;
            }
            return;
        }
        this.$emit('partnerContent', library);
    }

    private onBrokenImage() {
        const partnerImage = this.$refs.partnerThumbnail as any;
        partnerImage.src = this.partnerDefaultImage;
    }

    // ---------------------------------------------------------------------------
    // Methods
    private numberFormat(value: number) {
        return numberFormatWithTextSuffix(value);
    }
}
